var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageBackdropGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 602.797,
    height: 267.191,
    viewBox: "0 0 602.797 267.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.h{fill:#fff;}.b,.g{fill:#e45785;}.c{fill:#cdd5d7;}.d,.e,.f,.i{fill:none;}.d,.e,.f,.g,.h{stroke:#333;}.d,.e,.f,.g,.h,.i{stroke-width:3px;}.e,.h,.i{stroke-miterlimit:10;}.f{stroke-linejoin:bevel;}.i{stroke:#e45785;stroke-dasharray:12;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-739.827 -276.248)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1177.981,279.2a124.576,124.576,0,0,1,2.633,75.625l.506.14h-6.691l.726-.214A117.055,117.055,0,0,1,1177.981,279.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1174.178,354.965h-5.449l.038-.032c-11.082-13-16.072-27.965-14.049-42.131,1.9-13.274,9.808-25.239,22.308-33.845A118.017,118.017,0,0,0,1174.178,354.965Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1179,279.134c12.211,8.674,19.939,20.588,21.794,33.73,1.992,14.1-2.916,29.022-13.82,42l.117.1h-5.477A125.51,125.51,0,0,0,1179,279.134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1143.245,310.424c1.766-17.178,16.382-31.253,32.985-32.132-12.6,8.755-20.579,20.9-22.5,34.369-2.032,14.231,2.867,29.223,13.775,42.3h-2.7C1149.32,342.041,1141.261,325.416,1143.245,310.424Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1174.475,375.566V370.65l.46-.106-.266-1.157h6.125l-.266,1.157.751.172v4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1182.87,362.494h-9.984l-7.025-6.529h24.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1191.039,354.965h-2.866c10.775-13.074,15.612-28.048,13.607-42.24-1.9-13.432-9.783-25.6-22.241-34.43,16.6.887,31.206,14.958,32.972,32.143C1214.5,325.458,1206.875,341.247,1191.039,354.965Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 1.758,
    y2: 7.661,
    transform: "translate(1172.689 362.994)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 1.756,
    y2: 7.661,
    transform: "translate(1181.016 362.994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.805,
    height: 7.179,
    transform: "translate(1173.975 368.887)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1177.877,277.748c-17.285,0-33.266,14.5-35.129,32.624-1.937,14.636,5.506,31.537,21.967,45.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1190.777,355.855c17.119-14.586,24.176-30.78,22.229-45.483-1.861-18.124-17.842-32.624-35.129-32.624"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1185.423,360.084"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1177.9,277.748c-27.212,17.881-32.831,50.148-9.512,77.509"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1181.1,354.958a125.168,125.168,0,0,0-3.1-77.21c-9.77,25.382-10.91,51.364-3.321,77.145"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1187.353,355.188c22.94-27.308,17.442-59.375-9.455-77.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1180.885,360.041"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1172.689,362.994l-8.1-7.529h26.578l-8.1,7.529Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1133.088,363.613a3.547,3.547,0,0,0,.037-.5,3.47,3.47,0,0,0-3.471-3.469,3.511,3.511,0,0,0-.707.073,8.992,8.992,0,0,0-15.953-4.108,5.444,5.444,0,0,0-8.617,1.018,7.432,7.432,0,0,0-12.18,1.071,7.45,7.45,0,0,0-6.534,5.914Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1288.041,424.76a7.767,7.767,0,0,0-7.7-8.9,7.9,7.9,0,0,0-1.586.163,16.77,16.77,0,0,0-6.733-7.357,16.663,16.663,0,0,0-29.051-1.858,12.211,12.211,0,0,0-19.329,2.284,16.669,16.669,0,0,0-27.32,2.4,16.708,16.708,0,0,0-14.657,13.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1341.063,317.007a5.725,5.725,0,0,0-5.676-6.559,5.844,5.844,0,0,0-1.169.12,12.374,12.374,0,0,0-4.963-5.423,12.28,12.28,0,0,0-21.41-1.369,9,9,0,0,0-14.245,1.684,12.286,12.286,0,0,0-20.135,1.769,12.314,12.314,0,0,0-10.8,9.778Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M820.063,380.5a5.725,5.725,0,0,0-5.676-6.559,5.773,5.773,0,0,0-1.169.121,12.363,12.363,0,0,0-4.963-5.423,12.28,12.28,0,0,0-21.41-1.369,9,9,0,0,0-14.245,1.683,12.285,12.285,0,0,0-20.135,1.77,12.314,12.314,0,0,0-10.8,9.777Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1041.781,423.584a65.174,65.174,0,0,0-128.935,1.154,57.117,57.117,0,0,0-17.774.149,58.878,58.878,0,1,0,19.2,116.181l128.865-21.291a44.233,44.233,0,0,0-.444-87.242S1042.256,426.6,1041.781,423.584Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageBackdropGraphic);
export default __webpack_public_path__ + "static/media/pageBackdropGraphic.f515654ebd49ec4edbc1e93c5a8c5be4.svg";
export { ForwardRef as ReactComponent };